<div class="legend-panel-parent">
  <div class="legend-panel-body">
    <div class="global-panel-results">
      <div class="legend-panel-results-table global-panel-results-table">
      </div>
    </div>
  </div>
</div>